import {
  GroupOrderBagCancelButton,
  GroupOrderBagConvertButton,
  GroupOrderBagLeaveButton,
  GroupOrderBagShareButton,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderBagButton = {
  Convert: GroupOrderBagConvertButton,
  Share: GroupOrderBagShareButton,
  Cancel: GroupOrderBagCancelButton,
  Leave: GroupOrderBagLeaveButton,
};
